import { InjectionToken } from '@angular/core';

/** Keeps the shell's logout action independent of notification/navigation implementation. */
export const STOP_NOTIFICATION_SESSION = new InjectionToken<() => void>('STOP_NOTIFICATION_SESSION');
